module.exports = __webpack_public_path__ + "static/img/op_play.6d70a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top/op_play.png
// module id = mfAB
// module chunks = 0